import { Box, Typography } from '@mui/material';
import { formatAmountBRL, formatPercentageValue } from 'src/utils/number';

interface FicFidcPositionsSummaryProps {
  totalVlMercPosFinal: number;
  totalPercentage: number;
}

export default function FicFidcPositionsSummary({
  totalVlMercPosFinal,
  totalPercentage,
}: FicFidcPositionsSummaryProps) {
  return (
    <Box
      component="aside"
      role="status"
      sx={(theme) => ({
        width: '100%',
        border: `1px solid ${theme.palette.primary.light}`,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        borderRadius: 2,
        backgroundColor: theme.palette.primary.contrastText,
        boxShadow: theme.shadows[1],
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        flexWrap: 'wrap',
        gap: 2,
        justifyContent: 'space-between',
        p: { xs: 1.5, sm: 2 },
      })}>
      <Box>
        <Typography color="text.secondary" variant="caption">
          VALOR TOTAL DA COMPOSIÇÃO
        </Typography>
        <Typography color="primary.dark" fontWeight={700} variant="h6">
          {formatAmountBRL(totalVlMercPosFinal)}
        </Typography>
      </Box>
      <Box sx={{ textAlign: { sm: 'right' } }}>
        <Typography color="text.secondary" variant="caption">
          PARTICIPAÇÃO NO PL DO FUNDO
        </Typography>
        <Typography fontWeight={700} variant="h6">
          {formatPercentageValue(totalPercentage)}
        </Typography>
      </Box>
      <Typography sx={{ width: '100%' }} variant="body2">
        A soma dos valores da composição é de{' '}
        {formatAmountBRL(totalVlMercPosFinal)} e representa{' '}
        {formatPercentageValue(totalPercentage)} do patrimônio líquido total do
        fundo.
      </Typography>
    </Box>
  );
}
